import React from 'react';
import { motion } from 'framer-motion';
import { Terminal } from 'lucide-react';
export const OpeningHook = () => {
  return <section className="py-16 md:py-20 relative bg-brand-bg" data-id="element-137">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="bg-brand-surface border-l-4 border-brand-red p-6 sm:p-8 md:p-12 relative overflow-hidden" data-id="element-139">
          <div className="absolute top-0 right-0 p-4 opacity-10 hidden sm:block" data-id="element-140">
            <Terminal className="w-32 h-32" data-id="element-141" />
          </div>

          <div className="font-mono text-brand-red/60 text-xs sm:text-sm mb-5 md:mb-6 flex items-center gap-2 uppercase tracking-widest" data-id="element-142">
            <span className="w-2 h-2 bg-brand-red rounded-full animate-pulse shrink-0" data-id="element-143"></span>
            <span data-id="element-144">Registro de Sistema // Entrada Crítica</span>
          </div>

          <div className="space-y-5 md:space-y-6 text-base sm:text-lg md:text-xl text-gray-300 leading-relaxed relative z-10" data-id="element-145">
            <p data-id="element-146">
              <strong className="text-white" data-id="element-147">Son las 11:00 PM.</strong> Estás
              solo frente a la pantalla, con un nudo en el estómago y el pulso
              acelerado.
            </p>
            <p data-id="element-148">
              Acabas de cerrar una operación que nunca debiste abrir, aceptando
              una pérdida que duele. El silencio en tu habitación es
              ensordecedor.
            </p>
            <p className="text-brand-red font-medium" data-id="element-149">
              Sabes que si haces un clic más en este estado, podrías ver cómo
              meses de esfuerzo desaparecen en un segundo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};